export default __webpack_public_path__ + "static/media/no-right-cark.b192876c.svg";